import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M3 15h8v-2H3v2zm0 4h8v-2H3v2zm0-8h8V9H3v2zm0-6v2h8V5H3zm10 0h8v14h-8V5z"
}), 'VerticalSplit');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/VerticalSplit.js
// module id = 7025
// module chunks = 2